import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@app/features/users/user.model';

export function getUserLabel(user: User | null | undefined): string {
  if (!user) {
    return '';
  }

  if (user.firstName && user.lastName) {
    return `${user.lastName.toUpperCase()} ${user.firstName}`;
  }

  if (user.email) {
    return user.email;
  }

  if (user.username) {
    return user.username;
  }

  if (user.id) {
    return user.id;
  }

  return '';
}

@Pipe({
  name: 'userLabel',
})
export class UserLabelPipe implements PipeTransform {
  transform(user: User): string {
    return getUserLabel(user);
  }
}
